import React, { useState } from 'react';

export const DaySelector = ({ 
  initialSelectedDays = [], 
  onDaysChange, 
  disabledDays = [], 
  style = {},
  dayStyle = {},
  activeDayStyle = {},
  disabledDayStyle = {},
  allowMultiple = true
}) => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
  const [selectedDays, setSelectedDays] = useState(
    Array.isArray(initialSelectedDays) 
      ? initialSelectedDays.filter(day => daysOfWeek.includes(day))
      : []
  );

  const handleDayClick = (e, day) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabledDays.includes(day)) return;

    let newSelectedDays;
    
    if (allowMultiple) {
      if (selectedDays.includes(day)) {
        newSelectedDays = selectedDays.filter(d => d !== day);
      } else {
        newSelectedDays = [...selectedDays, day];
      }
    } else {
      // Single selection mode
      newSelectedDays = selectedDays.includes(day) ? [] : [day];
    }

    setSelectedDays(newSelectedDays);
    
    if (onDaysChange) {
      onDaysChange(newSelectedDays);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between',
      ...style 
    }}>
      {daysOfWeek.map((day) => {
        const isSelected = selectedDays.includes(day);
        const isDisabled = disabledDays.includes(day);
        
        return (
          <button
            key={day}
            onClick={(e) => handleDayClick(e, day)}
            disabled={isDisabled}
            style={{
              padding: '8px 4px',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              backgroundColor: isSelected ? '#4fd1c5' : '#f8f9fa',
              color: isSelected ? 'white' : isDisabled ? '#a0aec0' : '#4a5568',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              fontWeight: isSelected ? '600' : 'normal',
              flex: 1,
              margin: '0 2px',
              textAlign: 'center',
              textTransform: 'capitalize',
              fontSize: '14px',
              transition: 'all 0.2s ease',
              outline: 'none',
              minWidth: '32px',
              ...dayStyle,
              ...(isSelected ? { 
                borderColor: '#4fd1c5',
                boxShadow: '0 1px 3px rgba(79, 209, 197, 0.3)',
                ...activeDayStyle 
              } : {}),
              ...(isDisabled ? disabledDayStyle : {})
            }}
            aria-pressed={isSelected}
          >
            {day.substring(0, 3)}
          </button>
        );
      })}
    </div>
  );
};